<div class="o-grid">
   <div class="o-grid__col o-grid__col--full">
      <core-card>
         <h2 class="u-text u-fz--600">
            {{ 'clients.details' | translate }}
         </h2>
         <core-data-list [items]="clientDataList()" class="c-voyage__details" />
      </core-card>
   </div>

   <div class="o-grid__col o-grid__col--full u-card">
      <nav core-generic-tabs [config]="tabsConfig()" [activeTabId]="activeTabIdValue()"
         (tabChange)="onTabChange($event)" [hasTabErrors]="hasTabErrorsFunction"></nav>

      <div>
         <form>
            @if (activeTab()?.id === 'contact') {
            <app-contact></app-contact>
            }
            @if (activeTab()?.id === 'quotes') {
            <app-quotes></app-quotes>
            }
            @if (activeTab()?.id === 'booking') {
            <app-booking></app-booking>
            }
            @if (activeTab()?.id === 'notes') {
            <app-notes></app-notes>
            }
            @if (activeTab()?.id === 'rates') {
            <app-rates></app-rates>
            }
         </form>
      </div>
   </div>

</div>